var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import weixinJsSdk from 'weixin-js-sdk';
import { config } from '../config';
import { h5WechatApiClient } from './api';
import { LocalStorage } from './storage';
var WechatClient = /** @class */ (function () {
    function WechatClient() {
    }
    /**
     * 微信支付
     * @param {object} payData
     * @returns {Promise<object>}
     */
    WechatClient.prototype.initiateWechatPay = function (payData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO for debug ,optimize later
                // if (config.DEBUG) {
                // return new Promise((resolve, reject) => {
                //   setTimeout(() => {
                //     resolve(true);
                //   }, 20 * 1000);
                // });
                // }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        weixinJsSdk.chooseWXPay({
                            timestamp: payData.timeStamp,
                            nonceStr: payData.nonceStr,
                            package: payData.package,
                            signType: payData.signType,
                            paySign: payData.paySign,
                            success: function () {
                                // 支付成功后的回调函数
                                resolve();
                            },
                            fail: function (error) {
                                console.log(error);
                                reject(error);
                            },
                            cancel: function () {
                                console.log('user cancel order!');
                                reject(new Error('user cancel order!'));
                            },
                        });
                    })];
            });
        });
    };
    WechatClient.prototype.checkIsWechat = function () {
        return navigator.userAgent.match(/ MicroMessenger\//) !== null;
    };
    Object.defineProperty(WechatClient.prototype, "shareBgCache", {
        get: function () {
            var shareBgCacheLocalStorage = new LocalStorage('shareBgCache');
            var shareBgCache = JSON.parse(shareBgCacheLocalStorage.getItem('shareBgIndex') || '{}');
            if (shareBgCache.index === undefined) {
                shareBgCache = { updatedTimestamp: new Date().valueOf(), index: 0 };
                this.shareBgCache = shareBgCache;
            }
            return shareBgCache;
        },
        set: function (shareBgCache) {
            var shareBgCacheLocalStorage = new LocalStorage('shareBgCache');
            shareBgCacheLocalStorage.setItem('shareBgIndex', JSON.stringify(shareBgCache));
        },
        enumerable: true,
        configurable: true
    });
    WechatClient.prototype.updateShareBgCache = function (shareBgCache) {
        var totalShareImage = 2;
        var today = new Date();
        if (shareBgCache.index + 1 <= totalShareImage) {
            shareBgCache.index += 1;
        }
        else {
            shareBgCache.index = 0;
        }
        shareBgCache.updatedTimestamp = today.valueOf();
        this.shareBgCache = shareBgCache;
        return shareBgCache;
    };
    /**
     * 配置SDK
     *
     * @returns
     * @memberof WechatClient
     */
    WechatClient.prototype.configSdk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdkConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, h5WechatApiClient.getWechatSdkConfig()];
                    case 1:
                        sdkConfig = _a.sent();
                        weixinJsSdk.config(__assign({ debug: config.DEBUG && config.DEBUG_WECHAT, 
                            // debug: config.DEBUG, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            // appId: config.WECHAT_APP_ID_MP, // 必填，公众号的唯一标识
                            // timestamp: '', // 必填，生成签名的时间戳
                            // nonceStr: '', // 必填，生成签名的随机串
                            // signature: '', // 必填，签名
                            jsApiList: ['chooseWXPay', 'onMenuShareAppMessage', 'onMenuShareTimeline'] }, sdkConfig));
                        this._appId = sdkConfig.appId;
                        return [2 /*return*/, sdkConfig];
                }
            });
        });
    };
    /**
     * 获取Wechat App ID
     */
    WechatClient.prototype.getAppId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdkConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._appId) {
                            return [2 /*return*/, this._appId];
                        }
                        return [4 /*yield*/, this.configSdk()];
                    case 1:
                        sdkConfig = _a.sent();
                        return [2 /*return*/, sdkConfig.appId];
                }
            });
        });
    };
    return WechatClient;
}());
var wechatClient = new WechatClient();
export { wechatClient };
//# sourceMappingURL=wechat.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/wechat.js
// module id = 205
// module chunks = 0